import { Arrange, Pill, Typography, type TypographyProps } from "@aviary";
import { Size } from "@shared/types/sizes";

import * as styles from "./FilterTitle.styles";

interface Props extends TypographyProps {
  title: string;
  count: number;
  isBadge?: boolean;
}

const FilterTitle = ({ title, count, isBadge, ...typographyProps }: Props) => {
  const isCountAboveZero = Number.isInteger(count) && count > 0;

  if (isCountAboveZero && isBadge) {
    return (
      <Arrange justify="spaceBetween" alignment="center">
        <Typography {...typographyProps}>{title}</Typography>
        <Pill isColor="system" size={Size.SMALL} css={styles.pill}>
          {count}
        </Pill>
      </Arrange>
    );
  }

  if (isCountAboveZero) {
    const titleWithCount = `${title} (${count})`;

    return <Typography {...typographyProps}>{titleWithCount}</Typography>;
  }

  return <Typography {...typographyProps}>{title}</Typography>;
};

export { FilterTitle };
